/**
 * With this function you can easily extract values from a nested object
 * Loosely based on lodash.get
 */
export default function getObjectPropertyValue(obj, path, defaultValue = undefined) {
    const keys = typeof path === 'string' ? path.split('.') : path;
    return keys.reduce((result, key) => {
        if (typeof result === 'object' && result !== null) {
            if (key in result) {
                return result[key];
            }
            return defaultValue;
        }
        return defaultValue;
    }, obj);
}
//# sourceMappingURL=getObjectPropertyValue.js.map